interface StorageKeys {
	token: string;
}

export const storageKeys: StorageKeys = {
	token: "iost_token",
}